import React, { Fragment } from 'react'
import {useDrag} from "react-dnd";

const RowMove = (props) => {
    const cellData = props.original;
    
    let title = "test";
    if (cellData && cellData.name){
        title = cellData.name;
    }
 
    const [{isDragging}, drag] = useDrag({
        item:{
            name:"moveable-row", 
            type: "treeview-target",
            listIndex: 0,
            getPrevRow: "getPrevRow() {}",
            lowerSiblingCounts: [0],
            swapFrom: null,
            swapLength: null,
            swapDepth: null,
            treeIndex: 2,
            scaffoldBlockPxWidth: 28,
            node: {
                title: title,
                testId: cellData.id,
                testData: cellData,
                type: "test",
                expanded: false,
                selected: true,
                customerId: cellData.customerId,
                testType: cellData.treeviewtesttype,
                children: []
            },
            path: [
                1,
                2
            ],
            treeid: "rst__2",
            rowDirection: "ltr",
            children: "<DragSource(NodeRendererDefault) />"
            },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging()
        })
    });
    
  return (    
        <div ref={drag} >
            <span draggable={true} style={{cursor: isDragging ? "grabbing" :"grab"}} onDragStart={this.dragStart} onDragEnd={() => {return false}} id={"drag1"}>
                {isDragging ? 
                <Fragment><img style={{verticalAlign: "middle"}} src={'/images/drag.png'}/><span>{title}</span></Fragment>
                 : <img style={{verticalAlign: "middle"}} src={'/images/drag.png'}/>}
                </span>
        </div>         
  )
}

export default RowMove;



// WEBPACK FOOTER //
// ./src/components/table/cells/rowMove/index.js